import baseSpacingScale from './base-spacing-scale';

const borderWidths = baseSpacingScale;

export { borderWidths as default };
